/**
 * Minimal localization-form custom element (stub for theme compatibility).
 * Handles disclosure toggle and form submit on option select.
 */
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.disclosure = this.querySelector('.disclosure');
    if (!this.disclosure) return;
    const button = this.disclosure.querySelector('.disclosure__button');
    const list = this.disclosure.querySelector('.disclosure__list');
    if (!button || !list) return;
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', !open);
      list.hidden = open;
    });
    list.querySelectorAll('.disclosure__item a[data-value]').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const input = this.form.querySelector('input[name="country_code"], input[name="locale_code"]');
        if (input) {
          input.value = link.dataset.value;
          this.form.submit();
        }
      });
    });
  }
}
customElements.define('localization-form', LocalizationForm);
